import React from "react";
import PropTypes from "prop-types";
import uniqid from "uniqid";
import { useStoreState } from "easy-peasy";
import NavigationBtn from "../NavigationBtn";
import ProgressBar from "../ProgressBar";

function Navigation({ mobileResponsiveUtil, progressBar, showFeatures }) {
  const CONTAINER_ID = "interactiveExpNavigation";
  const { activeFeature, features } = useStoreState((state) => state.features);
  const isVisible = useStoreState((state) => state.navigation.isVisible);
  return (
    <>
      <nav
        id={CONTAINER_ID}
        className={`demo__navigation ${isVisible ? "is--visible" : ""}`}
      >
        <div className="demo__navigation-wrapper">
          {showFeatures && <ProgressBar content={progressBar} />}
          <ul className="demo-navigation__list">
            {showFeatures &&
              features &&
              features.map((feature, index) => (
                <NavigationBtn
                  key={uniqid("demo-nav-item-")}
                  timeMarker={feature.start || "00:00"}
                  iconUrl={feature.iconUrl}
                  iconAltText={feature.iconAltText}
                  index={index}
                  isActive={activeFeature === index}
                  label={feature.title}
                />
              ))}
          </ul>
        </div>
      </nav>
      <style jsx="true">
        {`
          #${CONTAINER_ID}.demo__navigation {
            height: ${mobileResponsiveUtil.getHeightValue(130)}px !important;
            padding-right: ${mobileResponsiveUtil.getWidthValue(
              84
            )}px !important;

            position: absolute !important;
            z-index: 3 !important;
            bottom: 0 !important;

            display: flex !important;

            width: 100% !important;

            background-image: linear-gradient(
              to top,
              rgba(35, 31, 32, 0.65) 0%,
              rgba(35, 31, 32, 0.65) 0.7336610000000001%,
              rgba(0, 0, 0, 0) 100%
            ) !important;

            justify-content: flex-end !important;
            transform: translate3d(0, 100%, 0) !important;
            opacity: 0 !important;
            transition: all 0.5s ease-in !important;
          }

          #${CONTAINER_ID}.demo__navigation.is--visible {
            transform: translate3d(0, 0, 0) !important;
            opacity: 1 !important;
          }

          #${CONTAINER_ID} .demo__navigation-wrapper {
            width: ${mobileResponsiveUtil.getWidthValue(934)}px !important;
          }

          #${CONTAINER_ID} .demo-navigation__list {
            display: flex !important;

            margin: 0 !important;
            padding: 0 !important;

            list-style-type: none !important;

            align-items: center !important;
            justify-content: flex-start !important;
          }

          #${CONTAINER_ID} .demo-navigation__list-item {
            height: ${mobileResponsiveUtil.getHeightValue(63)}px !important;

            flex: 1 !important;
            padding: 0 !important;
          }

          #${CONTAINER_ID}
            .demo-navigation__list-item
            + .demo-navigation__list-item {
            margin-left: ${mobileResponsiveUtil.getWidthValue(16)}px !important;
          }

          #${CONTAINER_ID} .demo-navigation__btn {
            display: flex !important;

            width: 100% !important;
            height: 100% !important;
            margin: 0 !important;
            padding: 0 !important;

            border: 1px solid #ffffff !important;
            border-radius: ${mobileResponsiveUtil.getWidthValue(
              500
            )}px !important;
            background: none !important;

            align-items: center !important;
            appearance: none !important;
            justify-content: center !important;
            box-shadow: none !important;
          }
          #${CONTAINER_ID} .demo-navigation__btn:hover,
          #${CONTAINER_ID} .demo-navigation__btn:hover * {
            cursor: pointer !important;
          }
          #${CONTAINER_ID} .demo-navigation__btn:focus {
            outline: 0 !important;
          }

          #${CONTAINER_ID} .demo-navigation__btn.animate__buttonBounce {
            transition: all 0.5s ease-in !important;

            border-color: #60a212 !important;
            background-color: #60a212 !important;
          }

          #${CONTAINER_ID} .demo-navigation__btn-icon {
            height: ${mobileResponsiveUtil.getHeightValue(32)}px !important;

            display: inline-block !important;

            width: auto !important;
          }

          #${CONTAINER_ID} .demo-navigation__btn-icon img,
          #${CONTAINER_ID} .demo-navigation__btn-icon svg {
            display: block !important;

            height: 100% !important;
          }

          #${CONTAINER_ID} .demo-navigation__btn-icon svg * {
            stroke: #ffffff !important;
          }
          #${CONTAINER_ID} .demo-navigation__btn-icon svg * {
            stroke: #ffffff !important;
          }

          #${CONTAINER_ID}
            .animate__buttonBounce
            .demo-navigation__btn-icon
            svg
            * {
            transition: all 0.5s ease-in !important;

            stroke-width: 4px !important;
          }

          #${CONTAINER_ID} .animate__buttonBounce {
            -webkit-animation-name: buttonBounce !important;
            animation-name: buttonBounce !important;
            animation-duration: 0.5s !important;
            animation-timing-function: ease-in !important;
          }

          @-webkit-keyframes buttonBounce {
            from {
              -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
            }
            50% {
              -webkit-transform: scale3d(1.2, 1.2, 1.2);
              transform: scale3d(1.2, 1.2, 1.2);
            }
            to {
              -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
            }
          }

          @keyframes buttonBounce {
            from {
              -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
            }
            50% {
              -webkit-transform: scale3d(1.2, 1.2, 1.2);
              transform: scale3d(1.2, 1.2, 1.2);
            }
            to {
              -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
            }
          }
        `}
      </style>
    </>
  );
}

Navigation.propTypes = {
  mobileResponsiveUtil: PropTypes.shape({
    getHeightValue: PropTypes.func,
    getWidthValue: PropTypes.func,
    getFontSize: PropTypes.func,
  }),
  progressBar: PropTypes.object,
  showFeatures: PropTypes.bool,
};

Navigation.defaultProps = {
  mobileResponsiveUtil: {
    getHeightValue: () => {},
    getWidthValue: () => {},
    getFontSize: () => {},
  },
  progressBar: {
    color: "#60a212",
  },
  showFeatures: true,
};

export default Navigation;
